import { ChangeDetectionStrategy, Component, ComponentRef, EventEmitter, Input, Output } from '@angular/core';
import { enumEntityModelCode } from '@data-layer/enums/entities';
import { LCLShipmentModel } from '@data-layer/models/lcl';
import { take } from 'rxjs/operators';
import { EntityModel } from '@data-layer/models/entities';
import { LclEntityEditComponent } from '../lcl-entity-edit/lcl-entity-edit.component';
import { AppService } from '@app/app.service';
import { enumShipmentState } from '@data-layer/enums/lcl';
import { enumLclTrackingStates } from '@enum/enumLclTrackingStates';

@Component({
  selector: 'app-lcl-shipment-contacts',
  templateUrl: './lcl-shipment-contacts.component.html',
  styleUrls: ['./lcl-shipment-contacts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LclShipmentContactsComponent {
  @Input() public shipment: LCLShipmentModel;
  @Input() public isEditable: boolean;
  @Input() public isManagement: boolean;
  @Output() public updateEntity: EventEmitter<EntityModel> = new EventEmitter<EntityModel>();
  @Output() public deleteEntity: EventEmitter<number> = new EventEmitter<number>();

  public enumEntityModelCode: typeof enumEntityModelCode = enumEntityModelCode;
  public validationKeys: string[] = ['name', 'phone', 'email', 'country', 'city', 'line1'];

  constructor(private appService: AppService) {}

  public onEditShipper(): void {
    const componentSidebarRef: ComponentRef<LclEntityEditComponent> = this.appService.openSidebar(LclEntityEditComponent, {
      sidebarHeaderText: 'LABELS.SHIPPER_EXPORTER',
    });

    componentSidebarRef.instance.entity = this.shipment.shipper;
    componentSidebarRef.instance.entityCode = enumEntityModelCode.SHIPPER;
    componentSidebarRef.instance.dataSaved.pipe(take(1)).subscribe((val: EntityModel) => {
      this.updateEntity.emit(val);
      this.appService.closeSidebar();
    });
  }

  public onEditConsignee(): void {
    const componentSidebarRef: ComponentRef<LclEntityEditComponent> = this.appService.openSidebar(LclEntityEditComponent, {
      sidebarHeaderText: 'LABELS.CONSIGNEE_RECEIVER',
    });

    componentSidebarRef.instance.entity = this.shipment.consignee;
    componentSidebarRef.instance.entityCode = enumEntityModelCode.CONSIGNEE;
    componentSidebarRef.instance.dataSaved.pipe(take(1)).subscribe((val: EntityModel) => {
      this.updateEntity.emit(val);
      this.appService.closeSidebar();
    });
  }

  public onEditNotifyParty(): void {
    const componentSidebarRef: ComponentRef<LclEntityEditComponent> = this.appService.openSidebar(LclEntityEditComponent, {
      sidebarHeaderText: 'LABELS.NOTIFY_PARTY',
    });

    componentSidebarRef.instance.entity = this.shipment.notifyParty;
    componentSidebarRef.instance.entityCode = enumEntityModelCode.NOTIFY_PARTY;
    componentSidebarRef.instance.dataSaved.pipe(take(1)).subscribe((val) => {
      this.updateEntity.emit(val);
      this.appService.closeSidebar();
    });
    componentSidebarRef.instance.dataCleared.pipe(take(1)).subscribe((val) => {
      this.deleteEntity.emit(val);
      this.appService.closeSidebar();
    });
  }

  public get isSkipValidation(): boolean {
    return this.isManagement ? false : !this.isEditableContacts;
  }

  public get isEditableContacts(): boolean {
    return this.shipment.state !== enumShipmentState.CANCELED && this.shipment.trackingState === enumLclTrackingStates.BOOKING_PLACED;
  }
}
